import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

const CenterContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box width="100vw" height="100vh" display="flex" alignItems="center" justifyContent="center" position="relative">
      {children}
    </Box>
  );
};

export default CenterContainer;
